
import { Component, Prop, Vue } from 'nuxt-property-decorator'

@Component
export default class ResponsiveImage extends Vue {
  @Prop({
    required: false,
    type: String,
    default: '',
  })
  src!: string

  @Prop({
    required: true,
    type: Array,
  })
  srcset!: string[]

  @Prop({
    required: false,
    type: String,
    default: '',
  })
  alt!: string

  @Prop({
    required: false,
    type: Boolean,
    default: false,
  })
  lazy!: boolean

  get srcsetStr () {
    return this.srcset.map((src, index) => `${src} ${index + 1}x`).join(', ')
  }

  get imageOptions () {
    return {
      src: this.src ? this.src : this.srcset[0],
      srcset: this.srcsetStr,
      alt: this.alt,
      loading: this.lazy ? 'lazy' : 'eager',
    }
  }
}
